import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/settings/billing")({
  // Component in lazy file for code splitting
});
